export default __webpack_public_path__ + "static/media/pic35-after.63c3257f.jpg";